import RemitApiCredentials from "components/components/Remit/AuthenticatedView/RemitApiCredentials/RemitApiCredentials";
import RemitUploadForm from "components/components/Remit/AuthenticatedView/RemitUploadForm/RemitUploadForm";
import useRemitRole from "hooks/useRemitRole";
import React from "react";

const AuthenticatedView: React.FC = () => {
  const { isRemitUser, isLoading } = useRemitRole();

  if (isLoading) {
    return null;
  }

  if (!isRemitUser) {
    return (
      <div data-test-id="remit-unauthorized-message">
        <p>
          You do not have permission to submit REMIT notifications. To request
          access, please contact your Elexon account manager.
        </p>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <RemitUploadForm />
      <div data-test-id="remit-api-credentials-section">
        <RemitApiCredentials />
      </div>
    </div>
  );
};

export default AuthenticatedView;
